import { Card } from '@mui/material';
import { useRecordContext } from 'react-admin';

import { GetInstrumentOneResponse } from '@Common/types/bo/instruments';

import { EmptyScreen, ShowSection } from '@sh4res/bo-common/components';
import { InstrumentDocumentsList } from '@sh4res/bo-common/components/Instruments/documents/InstrumentDocumentsList';

const NoDocumentsAvailable = () => (
  <EmptyScreen label="resources.bo_common.instruments.documents.not_available" />
);

export const InstrumentDocumentsSection = () => {
  const record = useRecordContext<GetInstrumentOneResponse>();

  if (!record) {
    return;
  }

  // do not display documents section for crypto instruments
  // display only kid for stock-us and stock-uv-eu instruments
  // display kid and prospectus for mutual-fund instruments
  return (
    <>
      {['crypto'].includes(record.type) && <NoDocumentsAvailable />}
      {['stock-us', 'stock-uv-eu'].includes(record.type) && (
        <>
          <ShowSection label="resources.bo_common.instruments.documents.kid">
            <Card sx={{ margin: 2 }}>
              <InstrumentDocumentsList type="kid" />
            </Card>
          </ShowSection>
          <ShowSection label="resources.bo_common.instruments.documents.complexity_and_target_market_assessment">
            <Card sx={{ margin: 2 }}>
              <InstrumentDocumentsList type="complexity_and_target_market_assessment" />
            </Card>
          </ShowSection>
        </>
      )}
      {['mutual-fund'].includes(record.type) && (
        <>
          <ShowSection label="resources.bo_common.instruments.documents.kid">
            <Card sx={{ margin: 2 }}>
              <InstrumentDocumentsList type="kid" />
            </Card>
          </ShowSection>
          <ShowSection label="resources.bo_common.instruments.documents.prospectus">
            <Card sx={{ margin: 2 }}>
              <InstrumentDocumentsList type="prospectus" />
            </Card>
          </ShowSection>
          <ShowSection label="resources.bo_common.instruments.documents.complexity_and_target_market_assessment">
            <Card sx={{ margin: 2 }}>
              <InstrumentDocumentsList type="complexity_and_target_market_assessment" />
            </Card>
          </ShowSection>
          <ShowSection label="resources.bo_common.instruments.documents.brochure">
            <Card sx={{ margin: 2 }}>
              <InstrumentDocumentsList type="brochure" />
            </Card>
          </ShowSection>
          <ShowSection label="resources.bo_common.instruments.documents.term_sheet">
            <Card sx={{ margin: 2 }}>
              <InstrumentDocumentsList type="term_sheet" />
            </Card>
          </ShowSection>
        </>
      )}
    </>
  );
};
